import type { InputStore } from '@/features/Sparten/nutz/useInputStore';
import type { Erstfahrzeug } from '@/features/Sparten/shared/schema/kfz/erstfahrzeugSchema/erstfahrzeugSchema';

const erstfahrzeug: Erstfahrzeug = {
  wkz: '',
  sfKlasseVK: '',
  sfKlasseKH: '',
  nutzerkreis: '',
  nutzungsart: '',
  juengsterFahrerGeburtsdatum: null,
  isVonPartner: false,
  gesellschaftID: 0,
  fahrleistung: 10000,
};

export const nutzInputDevMock: InputStore = {
  vorschaeden: [],
  erstfahrzeug,
  fahrerkreis: {
    alterJuengsterFahrer: 18,
    alterAeltesterFahrer: 18,
    isVnFahrer: true,
    isVnHauptnutzer: true,
    typ: 'offen',
    altersbeschraenkung: false,
  },
  versicherungsnehmer: {
    mitgliedschaften: {
      einzelhandelsverband: false,
      berufsstaendischeHandwerkerinnung: false,
      automobilClubVerkehr: false,
      autoClubEuropa: false,
      automobilclubVonDeutschland: false,
      allgemeinerDeutscherAutomobilClub: false,
      verbandBildungErziehung: false,
      unterstuetzungsVorsorgewerk: false,
      lehramtsanwaerterprojekt: false,
      berufsSozialwerk: false,
      deutscherBundeswehrverbandFoerdergesellschaft: false,
      vereinteDienstleistungsgewerkschaft: false,
      deutscherBeamtenbund: false,
    },
    isVorsteuerAbzugsberechtigt: false,
    isMitarbeiterAutohersteller: false,
    hasWohnsitzMin5JahreInBrd: false,
    minderjaehrigeKinder: {
      alterJuengstesKind: 14,
      alterAeltestesKind: 17,
      alter: 17,
    },
    hasMinderjaehrigeKinder: 'nein',
    hasFuehrerscheinInEUErworben: true,
    tarifgruppe: 'normal',
    speziellerArbeitgeber: 'Bausparkasse',
    branche: 'AndereKeineErwerbstaetigkeit',
    beruf: 'AltenpflegerIn',
    berufsstatus: 'angestellterAussendienst',
    isFirma: false,
    fuehrerscheindatum: new Date('2015-05-10T00:00:00.000Z'),
    isFullAge: false,
  },
  fahrzeug: {
    assistenzsysteme: {
      unfalldatenschreiber: 'nichtVorhanden',
      tagfahrlicht: 'nichtVorhanden',
      spurwechselassistent: 'nichtVorhanden',
      spurhalteassistent: 'nichtVorhanden',
      nachtsichtassistent: 'nichtVorhanden',
      fahrzeugortungssystem: 'nichtVorhanden',
      elektronischesStabilitaetsprogramm: 'nichtVorhanden',
      elektronischeWegfahrsperre: 'nichtVorhanden',
      elektronischeDiebstahlwarnanlage: 'nichtVorhanden',
      bremsassistent: 'nichtVorhanden',
      antiblockiersystem: 'nichtVorhanden',
      abstandsregeltempomat: 'nichtVorhanden',
    },
    erstmaligeZulassungAufVN: new Date('2019-12-31T23:00:00.000Z'),
    erstzulassung: new Date('2019-12-31T23:00:00.000Z'),
    erstbesitzer: false,
    nutzungsart: 'ausschliesslichPrivat',
    kilometerstand: 10000,
    fahrleistung: 10000,
    neuwert: 10000,
    leistung: 60,
    auslandsnutzung: 'keine',
    finanzierungsart: 'eigenfinanzierung',
    aufbauart: 'sonstigerAufbau',
    gesamtgewicht: 1000,
    gefahrgut: 'keinGefahrgut',
    anhaengerBauart: 'anhaenger',
    anhaengerVerleihung: false,
    gesellschaftZugfahrzeug: 97,
  },
  demvRabattiert: true,
  zahlweise: '1',
  zahlart: 'lastschrift',
  versicherungsbeginn: new Date('2022-06-20T22:00:00.000Z'),
  werkstattbindung: 'egal',
  tierbissfolgeschaeden: 'egal',
  fahrerschutzversicherung: false,
  schutzbriefleistungen: false,
  rabattschutzKfzHaftpflicht: false,
  kollisionMitTieren: false,
  gapDeckung: false,
  rabattschutzVollkasko: false,
  vorversicherung: {
    dauer: 1,
    hasVertragGekuendigt: false,
    gesellschaftID: 97,
    gesellschaftName: 'foobar',
  },
  sfKlasseVK: '',
  sfKlasseKH: 'SF_1_2_90',
  kaskoSB: {
    teilkasko: '',
    gleicheSB: true,
    vollkasko: '',
  },
  kaskoTyp: 'haftpflicht',
  saisonkennzeichen: {
    monatsEnde: '',
    monatsAnfang: '',
  },
  isSaisonkennzeichen: false,
  abweichenderHalter: {
    isHalterAbweichend: false,
    typ: '',
  },
  deckungssumme: 'mindGesetzlicheDeckung',
  allgemein: {
    wkz: 'bis3.5tWerk251',
    versicherungsart: 'versichererTarifWechsel',
    versicherungsartSelection: 'versichererTarifWechsel',
  },
};
